/* Carriely – kleurfilter op collectiepagina's: klik op een kleur en je ziet alleen die kleur (elke kleur is een eigen kaart). */
(() => {
  'use strict';
  const FAMILIES = [
    ['zwart', 'Zwart', '#151515'], ['bruin', 'Bruin & cognac', '#8a5532'], ['beige', 'Beige', '#d9c6a8'],
    ['wit', 'Wit & crème', '#f3eee4'], ['grijs', 'Grijs', '#9b9b9b'], ['groen', 'Groen', '#45603d'],
    ['blauw', 'Blauw', '#2f4b7c'], ['rood', 'Rood & bordeaux', '#962029'], ['roze', 'Roze', '#e3a8b4'],
    ['geel', 'Geel', '#dcc63c'], ['oranje', 'Oranje', '#d9792e'], ['paars', 'Paars', '#6c4b8c']
  ];
  let current = '';
  try { current = new URL(window.location.href).searchParams.get('kleur') || ''; } catch (e) { /* geen URL */ }

  function setup(root) {
    const bar = root.querySelector('[data-color-bar]');
    const grid = root.querySelector('.grid');
    if (!bar || !grid || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const cards = Array.from(grid.querySelectorAll('[data-card]'));
    const present = new Set();
    cards.forEach((c) => (c.dataset.families || '').split('|').forEach((f) => { if (f) present.add(f); }));
    const fams = FAMILIES.filter(([key]) => present.has(key));
    if (fams.length < 2) return;
    bar.innerHTML = '<span class="color-bar__label">Kleur</span><button type="button" class="color-chip" data-fam="" aria-pressed="true">Alle kleuren</button>'
      + fams.map(([key, label, hex]) => `<button type="button" class="color-chip" data-fam="${key}" aria-pressed="false"><span class="color-chip__dot" style="--dot:${hex}" aria-hidden="true"></span>${label}</button>`).join('');
    bar.hidden = false;
    const count = root.querySelector('.toolbar__count');
    const apply = (fam) => {
      if (fam && !present.has(fam)) fam = '';
      current = fam;
      let n = 0;
      cards.forEach((c) => {
        const ok = !fam || (c.dataset.families || '').includes(`|${fam}|`);
        c.hidden = !ok;
        if (!ok) return;
        n += 1;
        // Kaart met kleurbolletjes (niet opgesplitst): zet de foto op de gekozen kleur
        if (fam && !c.classList.contains('card--split')) {
          const sw = c.querySelector(`[data-card-swatch][data-family="${fam}"]`);
          if (sw && !sw.classList.contains('is-active')) sw.click();
        }
      });
      bar.querySelectorAll('.color-chip').forEach((b) => {
        const on = b.dataset.fam === fam;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      if (count) count.textContent = `${n} ${n === 1 ? 'artikel' : 'artikelen'}`;
      try {
        const url = new URL(window.location.href);
        if (fam) url.searchParams.set('kleur', fam); else url.searchParams.delete('kleur');
        window.history.replaceState({}, '', url.pathname + url.search);
      } catch (e) { /* bv. in een voorbeeldframe */ }
    };
    bar.addEventListener('click', (e) => {
      const b = e.target.closest('.color-chip');
      if (b) apply(b.dataset.fam);
    });
    apply(current);
  }

  document.querySelectorAll('[data-collection]').forEach((root) => {
    setup(root);
    // Na sorteren of filteren wordt de inhoud vervangen: opnieuw opbouwen en de gekozen kleur vasthouden
    new MutationObserver(() => setup(root)).observe(root, { childList: true });
  });
})();
